import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/Login';
import Dashboard from './pages/Dashboard';
import Drives from './pages/Drives';
import Enclosures from './pages/Enclosures';
import Pools from './pages/Pools';
import Volumes from './pages/Volumes';
import Shares from './pages/Shares';
import Targets from './pages/Targets';
import NetworkPage from './pages/Network';
import UsersPage from './pages/Users';
import AlertsPage from './pages/Alerts';
import Layout from './components/Layout';
import { AuthProvider, useAuth } from './context/AuthContext';

function AppRoutes() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-12 w-12 animate-spin rounded-full border-4 border-slate-300 border-t-indigo-600" />
      </div>
    );
  }
  if (!user) return <LoginPage />;
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/storage" element={<Dashboard />} />
        <Route path="/drives" element={<Drives />} />
        <Route path="/enclosures" element={<Enclosures />} />
        <Route path="/pools" element={<Pools />} />
        <Route path="/volumes" element={<Volumes />} />
        <Route path="/snapshots" element={<Placeholder title="Snapshots" />} />
        <Route path="/shares" element={<Shares />} />
        <Route path="/targets" element={<Targets />} />
        <Route path="/hosts" element={<Placeholder title="Hosts & Initiators" />} />
        <Route path="/replication" element={<Placeholder title="Replication" />} />
        <Route path="/files" element={<Placeholder title="File Browser" />} />
        <Route path="/users" element={<UsersPage />} />
        <Route path="/network" element={<NetworkPage />} />
        <Route path="/services" element={<Placeholder title="Services" />} />
        <Route path="/monitoring" element={<Placeholder title="Monitoring" />} />
        <Route path="/alerts" element={<AlertsPage />} />
        <Route path="/jobs" element={<Placeholder title="Jobs" />} />
        <Route path="/audit" element={<Placeholder title="Audit Log" />} />
        <Route path="/settings" element={<Placeholder title="System Settings" />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}

function Placeholder({ title }: { title: string }) {
  return (
    <div className="rounded-lg border border-slate-200 bg-white p-8 shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <h1 className="text-2xl font-bold">{title}</h1>
      <p className="mt-2 text-slate-500 dark:text-slate-400">This module is planned but not yet implemented.</p>
    </div>
  );
}

function App() {
  const [dark] = useState(true);

  useEffect(() => {
    document.documentElement.classList.toggle('dark', dark);
  }, [dark]);

  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
